
import Highlights from '../components/Highlights'
import Features from '../components/Features'
import HowItWorks from '../components/HowItWorks'
import Hero from '../components/Hero'
import { motion } from 'framer-motion'
import { PropertyContext } from "../context/PropertyContext"
import React, { useRef, useEffect, useState, useContext } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { FaBed, FaBath, FaDollarSign, FaMapMarkerAlt, FaQuoteLeft, FaRulerCombined } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import Steps from './../components/Steps';
import LHSection from './../components/LHSection';

gsap.registerPlugin(ScrollTrigger);
const reviews = [
  { id: 1, text: "This is an amazing service. I loved the professionalism and dedication! Highly recommended for everyone looking for quality work.", name: "Sarah Johnson", image: "https://randomuser.me/api/portraits/women/1.jpg" },
  { id: 2, text: "Incredible experience. The team went above and beyond to meet our expectations. Truly grateful!", name: "Michael Lee", image: "https://randomuser.me/api/portraits/men/2.jpg" },
  { id: 3, text: "Fast, efficient, and very professional. I will definitely work with them again in the future.", name: "Emily Davis", image: "https://randomuser.me/api/portraits/women/3.jpg" },
  { id: 4, text: "Top-notch quality and amazing customer support. They were with me every step of the way.", name: "James Carter", image: "https://randomuser.me/api/portraits/men/4.jpg" },
  { id: 5, text: "Fantastic job! Everything was delivered on time and above expectations.", name: "Olivia Brown", image: "https://randomuser.me/api/portraits/women/5.jpg" },
  { id: 6, text: "Very pleased with the result. They turned our vision into reality with ease.", name: "Daniel Wilson", image: "https://randomuser.me/api/portraits/men/6.jpg" },
  { id: 7, text: "The whole process was smooth and seamless. Excellent communication throughout.", name: "Sophia Miller", image: "https://randomuser.me/api/portraits/women/7.jpg" },
  { id: 8, text: "They know what they’re doing and it shows in their work. Highly trustworthy team.", name: "William Turner", image: "https://randomuser.me/api/portraits/men/8.jpg" },
  { id: 9, text: "Exceeded expectations in every way. Thank you for the amazing results!", name: "Ava Martinez", image: "https://randomuser.me/api/portraits/women/9.jpg" },
];

function Home() {
  const scrollContainerRef = useRef();
 const { properties, loading } = useContext(PropertyContext);
  const scrollByCard = (direction) => {
    const container = scrollContainerRef.current;
    const cardWidth = container.firstChild.offsetWidth + 16; // 16px margin
    container.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
  };

//   const properties = [
//   {
//   id: 1,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,

//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://img.freepik.com/premium-photo/stylized-blue-white-houses-arranged-row-blue-gradient-background_276930-6237.jpg?semt=ais_hybrid&w=740`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`, `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
//   },
// {
//   id: 2,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
// {
//   id: 3,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
// {
//   id: 4,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
// {
//   id: 5,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
//   ];

  const [index, setIndex] = useState(0);
  const containerRef = useRef(null);
  const wordOneRef = useRef(null);
  const wordTwoRef = useRef(null);
  
  useEffect(() => {
    gsap.fromTo(
      wordOneRef.current,
      { x: "-100%", opacity: 1 },
      {
        x: "0%",
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
        ease: "none",
      }
    );

    gsap.fromTo(
      wordTwoRef.current,
      { x: "100%", opacity: 1 },
      {
        x: "0%",
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
        ease: "none",
      }
    );
  }, []);

  const handlePrev = () => {
    setIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setIndex((prev) => (prev < reviews.length - 3 ? prev + 1 : prev));
  };

  const scrollRef = useRef(null);

  const scrollBy = (offset) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ top: offset, behavior: 'smooth' });
    }
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
    <Hero />
    <Steps />
    {/* <Highlights /> */}
    <HowItWorks />


 {/*................. reviews ...................*/}
 
 <section ref={containerRef} className="relative min-h-[120vh] py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center gap-12">
        <div
          ref={wordOneRef}
          className="text-9xl font-bold text-slate-500/30 whitespace-nowrap pointer-events-none"
        >
          SATISFIED
        </div>

        <div className="w-full">
         
          <div className="overflow-hidden">
            <div
              className="flex overflow-x-auto no-scrollbar transition-transform duration-500"
              style={{ transform: `translateX(-${index * 100 / 3}%)` }}
            >
              {reviews.map((review) => (
               <div className="min-w-[100%] md:min-w-[33.3333%] p-4">
               <div className="bg-teal-600 text-white p-6 shadow-md h-full flex flex-col justify-between relative overflow-hidden">
                 
                 {/* Quote Icon */}
                 <FaQuoteLeft className="text-6xl text-slate-700 absolute top-4 left-4 " />
                 
                 {/* Review Text */}
                 <p className="text-lg font-medium mb-4 mt-14">"{review.text}"</p>
         
                 {/* Reviewer Name */}
                 <p className="font-semibold text-slate-800 text-xl">{review.name}</p>
         
                 {/* Circular Image Bottom-Right */}
                 <img 
                   src={review.image} 
                   alt={review.name} 
                   className="w-16 h-16 rounded-full  absolute bottom-4 right-4 object-cover border-4 border-slate-800"
                 />
               </div>
             </div>

              
              ))}
            </div>
          </div>
        </div>

        <div
          ref={wordTwoRef}
          className="text-9xl font-bold text-slate-500/25 whitespace-nowrap pointer-events-none"
        >
          Clients
        </div>

        <div className="absolute bottom-8 left-4">
          <Link to="/reviews"> 
        <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold  bg-slate-900 shadow-xl text-lg group">
              <span className="absolute inset-0 bg-gradient-to-r from-teal-500 to-teal-500 group-hover:from-tslate-900 group-hover:to-teal-500 animate-slide-bg transition-all duration-500 ease-in-out"></span>
              <span className="relative z-10">See All</span>
            </button> </Link>
        </div>

        <div className="absolute bottom-8 right-4 justify-space-between flex gap-4">
          {/* <button onClick={handlePrev} className="p-3 bg-gray-800 text-white  shadow">
            <ChevronLeft />
          </button>
          <button onClick={handleNext} className="p-3 bg-gray-800 text-white shadow">
              <ChevronRight />
            </button> */}
           
        </div>
        {/* <div className="flex justify-center items-center gap-4 mb-6">
          
          </div> */}
      </div>
    </section>


    <Features />
    <LHSection/>


    </div>
  )
}

export default Home
